function getItemImage(image: string) {
  return `/catalogue/images/${encodeURIComponent(image)}`;
}

function getDefaultImage(taxonomyImage: string | null | undefined): string {
  return `/catalogue/noimage/${taxonomyImage || 'noimage'}`;
}

export const getCatalogueImage = (item: {
  env: any;
  image: string | null;
  taxonomyId: string | null;
}) => {
  const staticUrl = item.env.VITE_STATIC_URL;

  const path = item?.image
    ? getItemImage(item?.image)
    : getDefaultImage(item?.taxonomyId);

  return `${staticUrl}${path}.webp`;
};
